import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useSeoVirtualSubmit from "hooks/useSeoVirtualSubmit";
import InputArea from "components/form/InputArea";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import QuillEditor from "components/form/QuillEditor";

const SeoVirtualDrawer = ({ id, isViewMode }) => {
  const {
    content,
    setContent,
    register,
    handleSubmit,
    onSubmit,
    trigger,
    errors,
    loading,
  } = useSeoVirtualSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {isViewMode ? (
          <>
            <Title title={"View Seo Virtual"} />
          </>
        ) : (
          <>
            {id ? (
              <Title title={"Edit Seo Virtual"} description={""} />
            ) : (
              <Title title={"Add Seo Virtual"} description={""} />
            )}
          </>
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-12 gap-x-6 gap-y-4">
              <div className="col-span-12">
                <LabelArea required label="URL" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  label="URL"
                  name="url"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.url} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Title" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  maxLength={70}
                  label="Title"
                  name="title"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.title} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Keywords" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  label="Keywords"
                  name="keywords"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.keywords} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Description" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  maxLength={160}
                  label="Description"
                  name="description"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.description} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Content to Display" />
                <QuillEditor
                  required={true}
                  value={content}
                  readOnly={isViewMode}
                  onChangeFunction={(newContent) => setContent(newContent)}
                  register={register}
                  label="Content"
                  name="content"
                />

                <Error errorName={errors.content} />
              </div>
            </div>
          </div>

          {!isViewMode ? (
            <DrawerButton
              isSubmitting={loading}
              id={id}
              title={id ? "Update" : "Submit"}
            />
          ) : null}
        </form>
      </Scrollbars>
    </>
  );
};

export default SeoVirtualDrawer;
